import { createFileRoute } from "@tanstack/react-router";
import MenuScreen from "../Screens/Menu";

export const Route = createFileRoute("/menu")({
  component: RouteComponent,
});

function RouteComponent() {
  return <MenuScreen />;
}
